import { render, staticRenderFns } from "./GalleryListProfileLayout.vue?vue&type=template&id=a19a5796&scoped=true"
import script from "./GalleryListProfileLayout.vue?vue&type=script&lang=js"
export * from "./GalleryListProfileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a5796",
  null
  
)

export default component.exports